import * as React from "react";
import { useState } from "react";
import styled, { css } from "styled-components";
import { Form, Formik } from "formik";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import NumberUtils from "util/NumberUtils";
import fetch from "logic/rest/FetchProvider";
import { Button, Col, Modal, Row } from "components/bootstrap";
import FormikInput from "components/common/FormikInput";
import Spinner from "components/common/Spinner";
import { InputDescription, ModalSubmit, IfPermitted } from "components/common";
import { SOURCE_URL } from "report/Constants";
import { qualifyUrl } from "util/URLUtils";
const StyledDefList = styled.dl.attrs({
  className: "deflist"
})(
  ({ theme }) => css`
    &&.deflist {
      dt {
        margin-right: 10px;
      }
      dd {
        padding-left: ${theme.spacings.md};
        margin-left: 200px;
      }
    }
  `
);
const LabelSpan = styled.span(
  ({ theme }) => css`
    margin-left: ${theme.spacings.sm};
    font-weight: bold;
  `
);
const configUrl = qualifyUrl(`${SOURCE_URL}/config`);
const configKey = ["reporting", "config"];
const fetchReportingConfig = () => fetch("GET", configUrl);
const updateReportingConfig = (config) => fetch("PUT", configUrl, config);
const ReportingConfig = () => {
  const { data: config, isLoading } = useQuery({
    queryKey: configKey,
    queryFn: fetchReportingConfig
  });
  const queryClient = useQueryClient();
  const [showModal, setShowModal] = useState(false);
  const _saveConfig = (values) => {
    updateReportingConfig(values).then(() => {
      queryClient.invalidateQueries({
        queryKey: configKey
      });
      setShowModal(false);
    });
  };
  const _resetConfig = () => {
    setShowModal(false);
  };
  const modalTitle = "Configure Reporting";
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("h2", null, "Reporting"), /* @__PURE__ */ React.createElement("p", null, "These settings control the automated reporting system."), isLoading ? /* @__PURE__ */ React.createElement(Spinner, null) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledDefList, null, /* @__PURE__ */ React.createElement("dt", null, "Maximum Size of Reports History:"), /* @__PURE__ */ React.createElement("dd", null, NumberUtils.formatBytes(config.maximum_history_size))), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "report_configuration:edit" }, /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Button,
    {
      type: "button",
      bsSize: "xs",
      bsStyle: "info",
      onClick: () => {
        setShowModal(true);
      }
    },
    "Edit configuration"
  ))), /* @__PURE__ */ React.createElement(Modal, { show: showModal, onHide: _resetConfig }, /* @__PURE__ */ React.createElement(Formik, { onSubmit: _saveConfig, initialValues: config }, ({ isSubmitting }) => /* @__PURE__ */ React.createElement(Form, null, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, modalTitle)), /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { sm: 12 }, /* @__PURE__ */ React.createElement(
    FormikInput,
    {
      type: "number",
      name: "maximum_history_size",
      id: "maximum_history_size",
      label: /* @__PURE__ */ React.createElement(LabelSpan, null, "Maximum Report History Size")
    }
  ), /* @__PURE__ */ React.createElement(
    InputDescription,
    {
      help: /* @__PURE__ */ React.createElement(React.Fragment, null, "This is the maximum size of the report history stored in the database. When exceeded, oldest entries will be deleted.")
    }
  ))))), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(
    ModalSubmit,
    {
      onCancel: _resetConfig,
      isSubmitting,
      submitButtonText: "Update configuration",
      submitLoadingText: "Updating configuration..."
    }
  )))))));
};
export default ReportingConfig;
